import * as React from 'react';
import { Trans, useTranslation } from "react-i18next";
import { Typography } from '@mui/material';
import { createTheme } from '@mui/material/styles';


const theme = createTheme({
  typography: {
    big: {
      fontFamily: 'Nexa',
      /*fontFamily: 'Arista-Pro-Light-trial',*/
      fontSize: '20pt',
      lineHeight: '20pt',
      '@media (max-width: 992px)': {
        fontSize: '18pt',
        lineHeight: '20pt',
      },
    },
    normal: {
      fontFamily: 'Nexa',
      fontSize: '13pt',
      lineHeight: '17pt',
      /*'@media (max-width: 992px)': {
        fontSize: '20pt',
        lineHeight: '22pt',
      },*/
    },
    title: {
      fontFamily: 'Arista Bold',
      fontSize: '18pt',
      lineHeight: '18pt',
      textTransform: 'uppercase',
      /*'@media (max-width: 992px)': {
        fontSize: '20pt',
        lineHeight: '22pt',
      },*/
    },
    bold: {
      fontFamily: 'Nexa Bold',
      fontSize: '13pt',
      lineHeight: '14pt',
    },
    bolditalic: {
      fontFamily: 'Nexa Bold',
      fontSize: '13pt',
      lineHeight: '14pt',
      fontStyle: 'italic',

    },
    small: {
      fontFamily: 'Nexa',
      fontSize: '12pt',
      lineHeight: '12pt',
      fontWeight: 100,
      '@media (max-width: 992px)': {
        fontSize: '10pt',
        lineHeight: '10pt',
      },
    },
    extrasmall: {
      fontFamily: 'Nexa Bold',
      fontSize: '10pt',
      lineHeight: '50%',
    },
    imagedescription: {
      fontFamily: 'Arista Bold',
      fontSize: '12pt',
      lineHeight: '12pt',
    }
  },
});

export function Text({ variant, text, size, color }) {

  const { t } = useTranslation();

  return (
    <>

      <Typography
        variant={variant}
        theme={theme}
        sx={{ fontSize: size, color: color }}>

        <Trans
          i18nKey={text}
          components={{
            italic: <i />,
            strong: <strong />,
            underline: <u />,
            a: <a />
          }}
        />

      </Typography>

    </>
  )
}

export default Text